import { SEARCH_DEBOUNCE_TIME } from './constants';

export const getSearchDebounceTime = () => SEARCH_DEBOUNCE_TIME;
